<template>
  <div class="settlement-type-select-wrap">
    <div
      class="select-trigger"
      :class="{ 'is-open': dropdownVisible, 'is-disabled': disabled }"
      @click="handleTriggerClick"
    >
      <span
        class="selected-summary"
        :class="{ placeholder: !selectedLabelText }"
        :title="selectedLabelText || '请选择结算类型'"
      >
        {{ selectedLabelText || '请选择结算类型' }}
      </span>
      <i class="el-icon-arrow-down arrow-icon" :class="{ 'is-open': dropdownVisible }"></i>
    </div>

    <div v-show="dropdownVisible" class="dropdown-panel">
      <div class="dropdown-scroll">
        <el-tree
          v-if="treeOptions.length > 0"
          ref="tree"
          :data="treeOptions"
          node-key="id"
          :props="defaultProps"
          :expand-on-click-node="false"
          default-expand-all
        >
          <span class="tree-node" slot-scope="{ data }">
            <el-checkbox
              v-if="isLeafNode(data)"
              :checked="!!data.checked"
              @change="handleNodeChange(data)"
            >
              {{ data.show_name }}
            </el-checkbox>
            <span v-else class="tree-parent-label">{{ data.show_name }}</span>
          </span>
        </el-tree>
        <div v-else class="empty-text">暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SettlementTypeSelect',
  props: {
    selectedId: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      treeOptions: [],
      optionLabelMap: {},
      selectedIdsInternal: [],
      dropdownVisible: false,
      defaultProps: {
        children: 'children',
        label: 'show_name',
      },
    }
  },
  computed: {
    selectedLabelText() {
      return this.selectedIdsInternal
        .map((id) => this.optionLabelMap[String(id)] || '')
        .filter((label) => label)
        .join('、')
    },
  },
  watch: {
    selectedId: {
      handler(val) {
        this.selectedIdsInternal = this.normalizeIds(val)
        this.syncCheckedState()
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    normalizeIds(val) {
      if (!Array.isArray(val)) return []
      return val.map((item) => String(item)).filter((item) => item)
    },
    isLeafNode(node) {
      return !node.children || node.children.length === 0
    },
    walkNodes(nodes, callback) {
      ;(nodes || []).forEach((node) => {
        callback(node)
        if (node.children && node.children.length > 0) {
          this.walkNodes(node.children, callback)
        }
      })
    },
    buildTreeOptions(list) {
      const labelMap = {}
      const cloneNodes = (nodes) => {
        return (nodes || []).map((item) => {
          const children = cloneNodes(item.children || [])
          const nextNode = {
            id: String(
              item.id || item.settlement_type_id || item.value || item.key || ''
            ),
            show_name:
              item.show_name ||
              item.settlement_name ||
              item.name ||
              item.label ||
              '',
            is_department:
              item.is_department !== undefined ? String(item.is_department) : '',
            checked: false,
            children,
          }
          if (children.length === 0 && nextNode.id && nextNode.show_name) {
            labelMap[nextNode.id] = nextNode.show_name
          }
          return nextNode
        })
      }
      return {
        treeOptions: cloneNodes(list).filter((item) => item.id && item.show_name),
        labelMap,
      }
    },
    syncCheckedState() {
      const validIds = Object.keys(this.optionLabelMap)
      if (validIds.length > 0) {
        const validIdSet = new Set(validIds)
        this.selectedIdsInternal = this.selectedIdsInternal.filter((id) =>
          validIdSet.has(String(id))
        )
      }
      const selectedIdSet = new Set(this.selectedIdsInternal)
      this.walkNodes(this.treeOptions, (node) => {
        node.checked = this.isLeafNode(node) && selectedIdSet.has(String(node.id))
      })
    },
    handleNodeChange(node) {
      if (this.disabled || !this.isLeafNode(node)) return
      const nodeId = String(node.id)
      const nextSet = new Set(this.selectedIdsInternal)
      if (nextSet.has(nodeId)) {
        nextSet.delete(nodeId)
      } else {
        nextSet.add(nodeId)
      }
      this.selectedIdsInternal = Array.from(nextSet)
      this.syncCheckedState()
      this.$emit('change', this.selectedIdsInternal)
    },
    handleTriggerClick() {
      if (this.disabled) return
      this.dropdownVisible = !this.dropdownVisible
    },
    handleDocumentClick(event) {
      if (!this.$el.contains(event.target)) {
        this.dropdownVisible = false
      }
    },
    async getSettlementTypeList() {
      const param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/simple_settlement',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      const rawList = res.datas.listInfo || res.datas.list || res.datas.info || []
      const { treeOptions, labelMap } = this.buildTreeOptions(rawList)
      this.treeOptions = treeOptions
      this.optionLabelMap = labelMap
      this.syncCheckedState()
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.getSettlementTypeList()
  },
  mounted() {
    document.addEventListener('click', this.handleDocumentClick)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleDocumentClick)
  },
}
</script>

<style lang="less" scoped>
.settlement-type-select-wrap {
  position: relative;
  width: 100%;
}

.select-trigger {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 40px;
  padding: 0 36px 0 14px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  box-sizing: border-box;
  cursor: pointer;
  transition: border-color 0.2s;
}

.select-trigger.is-open,
.select-trigger:hover {
  border-color: #409eff;
}

.select-trigger.is-disabled {
  background: #f5f7fa;
  border-color: #e4e7ed;
  cursor: not-allowed;
}

.selected-summary {
  display: block;
  width: 100%;
  line-height: 22px;
  color: #606266;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.selected-summary.placeholder {
  color: #c0c4cc;
}

.arrow-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  margin-top: -7px;
  color: #c0c4cc;
  transition: transform 0.2s;
}

.arrow-icon.is-open {
  transform: rotate(180deg);
}

.dropdown-panel {
  position: absolute;
  left: 0;
  right: 0;
  top: 44px;
  z-index: 20;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.dropdown-scroll {
  max-height: 260px;
  overflow-y: auto;
  padding: 8px 0;
}

.tree-node {
  display: inline-flex;
  align-items: center;
  width: 100%;
  padding-right: 12px;
  box-sizing: border-box;
}

.tree-parent-label {
  display: inline-block;
  color: #303133;
  font-weight: 600;
}

.empty-text {
  padding: 12px 16px;
  color: #909399;
  font-size: 14px;
}

/deep/ .el-tree-node__content {
  min-height: 34px;
}

/deep/ .el-checkbox__label {
  color: #606266;
}
</style>
